<template>
<div class="activity-wrapper">

    <div class="activity-header">
        <h5>Recent Activities</h5>
         <!-- CLOSE BUTTON -->
        <button
            class="close-btn"
            @click="$emit('close')"
        >
            <i class="fa fa-times"></i>
        </button>
    </div>

    <div
        v-for="activity in activities"
        :key="activity.id"
        class="activity-item"
    >

        <!-- ICON -->
        <div
            class="activity-icon"
            :class="`activity-${activity.type}`"
        >
            <i :class="getIcon(activity.type)"></i>
        </div>

        <!-- CONTENT -->
        <div class="activity-content">

            <div class="activity-top">

                <h6>
                    {{ getTitle(activity) }}
                </h6>

                <small>
                    {{ formatDate(activity.date) }}
                </small>

            </div>

            <div
                v-if="activity.metadata?.subject"
                class="activity-subject"
            >
                {{ activity.metadata.subject }}
            </div>

            <div
                v-if="activity.notes"
                class="activity-notes"
            >
                {{ activity.notes }}
            </div>

            <div class="activity-footer">

                <span class="activity-user">
                    {{ activity.created_by_name }}
                </span>

                <span
                    v-if="activity.outcome"
                    class="activity-badge"
                >
                    {{ activity.outcome }}
                </span>

            </div>

        </div>

    </div>

</div>
</template>

<script>
export default {

    props: {
        activities: {
            type: Array,
            default: () => []
        }
    },

    methods: {

        getIcon(type) {

            const icons = {
                call: 'fa fa-phone',
                email: 'fa fa-envelope',
                meeting: 'fa fa-users',
                message: 'fa fa-comment',
                other: 'fa fa-info-circle'
            };

            return icons[type] || 'fa fa-bell';
        },

        getTitle(activity) {

            const titles = {
                call: 'Phone Call',
                email: 'Email',
                meeting: 'Meeting',
                message: 'Message',
                other: activity.label || 'Other'
            };

            return titles[activity.type] || 'Activity';
        },

        formatDate(date) {

            return new Date(date).toLocaleDateString();
        }
    }
}
</script>

<style scoped>
.activity-wrapper {
    background: #fff;
    border-radius: 12px;
    border: 1px solid #edf2f7;
    padding: 18px;
    max-height: 80vh;
    overflow-y: scroll;
}

.transition-layout {
    transition: all 0.3s ease;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.25s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    opacity: 0;
    transform: translateX(20px);
}

.activity-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    border-bottom: 1px solid #f1f5f9;
    padding-bottom: 10px;
}

.close-btn {
    width: 30px;
    height: 30px;
    border: none;
    background: #f1f5f9;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.close-btn:hover {
    background: #e2e8f0;
}

.activity-toggle-btn {
    display: flex;
    align-items: center;
    gap: 6px;
}
.activity-item {
    display: flex;
    gap: 12px;
    margin-bottom: 18px;
    position: relative;
}

.activity-item:last-child {
    margin-bottom: 0;
}

.activity-icon {
    width: 38px;
    height: 38px;
    min-width: 38px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 13px;
}

.activity-call {
    background: #2563eb;
}

.activity-email {
    background: #7c3aed;
}

.activity-meeting {
    background: #059669;
}

.activity-message {
    background: #ea580c;
}

.activity-other {
    background: #475569;
}

.activity-content {
    width: 100%;
    min-width: 0;
}

.activity-top {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: start;
}

.activity-top h6 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
}

.activity-top small {
    color: #94a3b8;
    font-size: 11px;
    white-space: nowrap;
}

.activity-subject {
    margin-top: 5px;
    font-size: 12px;
    color: #475569;
    font-weight: 500;
}

.activity-notes {
    margin-top: 6px;
    font-size: 12px;
    color: #64748b;
    line-height: 1.5;
}

.activity-footer {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.activity-user {
    font-size: 11px;
    color: #94a3b8;
}

.activity-badge {
    background: #dcfce7;
    color: #166534;
    padding: 3px 8px;
    border-radius: 30px;
    font-size: 10px;
    font-weight: 600;
    text-transform: capitalize;
}

@media(max-width: 991px){

    .activity-wrapper{
        margin-top: 20px;
    }
}
</style>